import React, {Component} from 'react'
import {connect} from 'react-redux'
import {selectEwUser} from '../../AcctMgt/action/userActions'
import {getUserFolders} from '../action/ftpFolderActions'
import {withRouter} from 'react-router-dom'
import {Dropdown} from 'react-bootstrap'



class UsersDD extends Component {
    
    getGroup(groupList){
   
        var groups = ''
           if(groupList && groupList.length > 0){
               groupList.forEach(id => {
   
                   var group = this.props.groups.filter(g =>{
                 
                       return g['groupId'] == id
                   })  
           
                   if(group[0])
                   groups += group[0]['name'] + ','
               });
             
           } 
           if(groups.length > 0){
           groups = groups.substring(0, groups.length - 1)
           }
           return groups;
       }

   render(){

    const DD =(()=>{
        if(this.props.users){
            return <Dropdown>
            <Dropdown.Toggle style={{fontFamily : 'lato', fontWeight : 'bold', fontSize : '13px', backgroundColor: 'hsla(0,0%,100%,.3)', border : 'none',   textTransform: 'uppercase'
}} variant="success" id="dropdown-basic">
              {this.props.user ? `${this.props.user['firstName']} ${this.props.user['lastName']}` : 'Select a User'}
            </Dropdown.Toggle>
          
          <Dropdown.Menu>
                  <Dropdown.Header>Users</Dropdown.Header>
                  {this.props.users.map((g, index)=>{
                      return  <Dropdown.Item onSelect={()=>{
                          this.props.dispatch(selectEwUser(g))
                          this.props.dispatch(getUserFolders(this.props.selectedCo.company['Public Id of Distributor'] ?
                          this.props.selectedCo.company['Public Id of Distributor'] :
                          this.props.selectedCo.company['Public Id of Manufacturer']  , g['FTP']))

                      }} key={g['email']} >{`${g['firstName']} ${g['lastName']}`} <small>{this.getGroup(g['groupIdList'])} </small></Dropdown.Item>
                  })}
          </Dropdown.Menu>
          
          
          </Dropdown>
        }
        return ''
    })
        return (
            <div>
                <DD />
            </div>
        )
    }
}

const mapStateToProps = state => (
    {
    user : state.acct.user.selectedUser,
    loading : state.acct.user.filterLoading,
    selectedCo : state.acct.ewCo.globalSelect,

  });

  export default connect(mapStateToProps)(withRouter(UsersDD))